import { render, staticRenderFns } from "./editor-help.vue?vue&type=template&id=6b12daa8&"
import script from "./editor-help.vue?vue&type=script&lang=js&"
export * from "./editor-help.vue?vue&type=script&lang=js&"
import style0 from "./editor-help.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports